let sizeChartBlock = document.querySelector('.best-fit-size-chart');
let sizeVariantLabel = document.querySelector('.swatches .swatch-label:has(input[name="Size"])');

const updateSizeChartPosition = () => {
  if (!sizeChartBlock || !sizeVariantLabel) {
    const interval = setInterval(() => {
      sizeChartBlock = document.querySelector('.best-fit-size-chart');
      sizeVariantLabel = document.querySelector('.swatches .swatch-label:has(input[name="Size"])');

      if (sizeChartBlock && sizeVariantLabel) {
        sizeVariantLabel.appendChild(sizeChartBlock);
        clearInterval(interval);
      }
    }, 500);
  } else {
    const newVariantLabel = document.querySelector('.swatches .swatch-label:has(input[name="Size"])');

    newVariantLabel.innerHTML = sizeVariantLabel.innerHTML;
  }
};

window.addEventListener('DOMContentLoaded', updateSizeChartPosition);
window.addEventListener('click', updateSizeChartPosition);
